import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatEUR(v) {
  if (v === null || v === undefined || v === "") return "—";
  try {
    return new Intl.NumberFormat("it-IT", {
      style: "currency", currency: "EUR", maximumFractionDigits: 2,
    }).format(Number(v));
  } catch {
    return `${v}`;
  }
}

// Sprint FIX-MONITOR2 — Resa UNIFORME del campo Acquisto mascherato in Monitor Cliente.
// Quando il valore è null/undefined (mascheramento backend o per-riga), ritorna
// stringa vuota: niente "—", niente icona, niente "0". TUTTE le card devono
// usare questo helper per i campi ACQUISTO/COSTO/PROVENTO oscurabili.
export function formatEURMasked(v) {
  if (v === null || v === undefined || v === "") return "";
  return formatEUR(v);
}
